<div class="container-xl body__wrapper">
            <div class="body__description">
                <h1 class="title text-center text-md-start">
                    {{ 'fe_step2_list_vehicle_h1_title' | translate }}
                </h1>
                <span class="subtitle">
                    {{
                        'fe_step2_list_vehicle_span_subtitle' | translate
                    }}</span
                >
                <div class="mobile learnMore-btn">
                    <svg
                        class="svg"
                        xmlns="http://www.w3.org/2000/svg"
                        width="25.142"
                        height="24.581"
                        viewBox="0 0 25.142 24.581"
                    >
                        <path
                            id="question"
                            d="M24.44,0H.6A.646.646,0,0,0,0,.6V24.04c0,.6.7.7,1.1.3l5.609-5.709a.759.759,0,0,1,.4-.2H24.541a.646.646,0,0,0,.6-.6V.6A.859.859,0,0,0,24.44,0ZM12.521,14.424h0a1,1,0,1,1,0-2,1.077,1.077,0,0,1,1,1A.946.946,0,0,1,12.521,14.424Zm1.8-4.608c-.1.1-.2.1-.3.2a.724.724,0,0,0-.4.6,1.2,1.2,0,0,1-1.2,1.1,1.122,1.122,0,0,1-1.2-1v-.1a3.09,3.09,0,0,1,1.7-2.5,1.061,1.061,0,0,0,.6-1.1,1.087,1.087,0,0,0-.8-.8.779.779,0,0,0-.8.2.907.907,0,0,0-.3,1c0,.2,0,.4-.2.5a1.114,1.114,0,0,1-1.9-.7,3.2,3.2,0,0,1,1.1-2.4,3.228,3.228,0,0,1,2.5-.7A3.211,3.211,0,0,1,14.324,9.816Z"
                            fill="#ca93fe"
                        ></path>
                    </svg>
                    <button
                        *ngIf="!international"
                        class="text f-weight"
                        (click)="modalPayMethod1.fire()"
                    >
                        {{
                            'fe_step2_list_vehicle_button_learn_more'
                                | translate
                        }}
                    </button>
                </div>
            </div>
            <div class="body__content">
                <div class="body__filter desktop-sidebar-sort">
                    <fe-filters
                        [isSidebarVisible]="false"
                        [international]="international"
                        (toggleSidebar)="onToggleSidebar()"
                        (sortChange)="onSortChange($event)"
                    ></fe-filters>
                </div>
                <div class="body__cars">
                    <div class="available__cars__info">
                        <div class="left">
                            <span class="subtitle">
                                {{ vehicles.length }}
                                <span class="counter-text counter-text--desktop">{{
                                    (vehicles.length === 1
                                        ? 'fe_step2_list_vehicle_span_counter_vehicles_text_singular'
                                        : 'fe_step2_list_vehicle_span_counter_vehicles_text'
                                    ) | translate
                                }}</span>
                                <span class="counter-text counter-text--mobile">{{
                                    (vehicles.length === 1
                                        ? 'fe_step2_list_vehicle_span_counter_vehicles_text_singular_mobile'
                                        : 'fe_step2_list_vehicle_span_counter_vehicles_text_mobile'
                                    ) | translate
                                }}</span>
                                <br class="mobile" />
                            </span>
                        </div>
                        <div class="right">
                            <div
                                class="desktop learnMore-btn"
                                *ngIf="!international"
                            >
                                <svg
                                    class="svg"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="25.142"
                                    height="24.581"
                                    viewBox="0 0 25.142 24.581"
                                >
                                    <path
                                        id="question"
                                        d="M24.44,0H.6A.646.646,0,0,0,0,.6V24.04c0,.6.7.7,1.1.3l5.609-5.709a.759.759,0,0,1,.4-.2H24.541a.646.646,0,0,0,.6-.6V.6A.859.859,0,0,0,24.44,0ZM12.521,14.424h0a1,1,0,1,1,0-2,1.077,1.077,0,0,1,1,1A.946.946,0,0,1,12.521,14.424Zm1.8-4.608c-.1.1-.2.1-.3.2a.724.724,0,0,0-.4.6,1.2,1.2,0,0,1-1.2,1.1,1.122,1.122,0,0,1-1.2-1v-.1a3.09,3.09,0,0,1,1.7-2.5,1.061,1.061,0,0,0,.6-1.1,1.087,1.087,0,0,0-.8-.8.779.779,0,0,0-.8.2.907.907,0,0,0-.3,1c0,.2,0,.4-.2.5a1.114,1.114,0,0,1-1.9-.7,3.2,3.2,0,0,1,1.1-2.4,3.228,3.228,0,0,1,2.5-.7A3.211,3.211,0,0,1,14.324,9.816Z"
                                        fill="#ca93fe"
                                    ></path>
                                </svg>
                                <button
                                    *ngIf="!international"
                                    class="text f-weight"
                                    (click)="modalPayMethod1.fire()"
                                >
                                    {{
                                        'fe_step2_list_vehicle_button_learn_more'
                                            | translate
                                    }}
                                </button>
                            </div>
                            <div class="mobile">
                                <details class="sort-dropdown sort-dropdown--mobile">
                                    <summary>
                                        <img
                                            alt=""
                                            class="sort-dropdown__icon"
                                            [src]="'images/arrows.svg' | cdn"
                                        />
                                        <span>{{
                                            selectedSortLabelKey | translate
                                        }}</span>
                                    </summary>
                                    <fe-filters
                                        [isSidebarVisible]="false"
                                        [international]="international"
                                        (toggleSidebar)="onToggleSidebar()"
                                        (sortChange)="onSortChange($event)"
                                    ></fe-filters>
                                </details>
                            </div>
                        </div>
                    </div>
                    <div class="vehicle-toolbar desktop">
                        <div class="vehicle-type-filters">
                            <button
                                *ngFor="let type of visibleVehicleTypes"
                                class="vehicle-type-pill"
                                [class.active]="selectedTypeId === type.id"
                                type="button"
                                (click)="onTypeClick(type)"
                            >
                                <img alt="" [src]="getTypeIcon(type)" />
                                <span>{{ getTypeName(type) }}</span>
                            </button>
                        </div>
                        <details class="sort-dropdown">
                            <summary>
                                <img
                                    alt=""
                                    class="sort-dropdown__icon"
                                    [src]="'images/arrows.svg' | cdn"
                                />
                                <span>{{
                                    selectedSortLabelKey | translate
                                }}</span>
                            </summary>
                            <fe-filters
                                [isSidebarVisible]="false"
                                [international]="international"
                                (toggleSidebar)="onToggleSidebar()"
                                (sortChange)="onSortChange($event)"
                            ></fe-filters>
                        </details>
                    </div>
                    <div class="free__days" *ngIf="hasFreeDays">
                        <span
                            class="free__days__icon material-symbols-outlined"
                            aria-hidden="true"
                            >event_available</span
                        >
                        <div class="free__days__copy">
                            <p class="free__days__title">
                                {{
                                    freeDaysTitleKey
                                        | translate
                                        | replace: { days: freeDays }
                                }}
                            </p>
                            <p class="free__days__text">
                                {{
                                    'fe_step2_list_vehicle_free_days_desc'
                                        | translate
                                        | replace
                                            : {
                                                  days: rentalDays,
                                                  chargedDays: chargedDays
                                              }
                                }}
                            </p>
                        </div>
                    </div>
                    <div class="cars__cards d-flex flex-column">
                        <fe-card-vehicle
                            *ngFor="let vehicle of vehicles"
                            [vehicle]="vehicle"
                            [discount]="discountOffice"
                            [international]="international"
                            [rateWeekly]="rateWeekly"
                            [currency]="currency"
                            [discountOffice]="getDiscountForMethod('office')"
                            [discountPrepaid]="getDiscountForMethod('prepay')"
                            [rentalDays]="rentalDays"
                            (detailOpened)="onDetailOpened($event)"
                        ></fe-card-vehicle>
                    </div>
                    <div class="additional__text">
                        <span class="text">
                            {{
                                'fe_step2_list_vehicle_span_bottom_text'
                                    | translate
                            }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
